import { IPublicClientApplication } from '@azure/msal-browser';
import { JudgingQuestion } from '../../models';
import { ApiEndpointCallStatesStore } from '../api-endpoint-call-states-store';
import { FetchContext } from '../fetch-context';
import { promiseWithObservableState } from '../promise-with-observable-state';
import { withApiAccessToken } from '../with-api-access-token';
import {
  deleteJudgingQuestion,
  getJudgingQuestions,
  upsertJudgingQuestions,
} from './index';

export const createAdminAwardsJudgingQuestionsApiEndpoints = (
  fetchContext: FetchContext,
  apiEndpointCallStates: ApiEndpointCallStatesStore,
) => ({
  getJudgingQuestions: (instance: IPublicClientApplication, awardId: number) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => getJudgingQuestions(fetchContext, awardId, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('getJudgingQuestions', isInFlight);
    },
  ),
  upsertJudgingQuestions: (instance: IPublicClientApplication, awardId: number, judgingQuestions: JudgingQuestion[]) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => upsertJudgingQuestions(fetchContext, awardId, judgingQuestions, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('upsertJudgingQuestions', isInFlight);
    },
  ),
  deleteJudgingQuestion: (instance: IPublicClientApplication, awardId: number, questionId: number) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => deleteJudgingQuestion(fetchContext, awardId, questionId, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('deleteJudgingQuestion', isInFlight);
    },
  ),
});
